import { useAuth } from 'auth/auth-provider/AuthProvider';
import { PropsWithChildren } from 'react';

export const AuthorizationGuard = ({ children }: PropsWithChildren) => {
  const auth = useAuth();
  const unauthorized = auth.identificationState !== 'authenticated';

  if (unauthorized) auth.login({ authSuccessRedirect: '/' });

  return children;
};
